<template lang="html">
  <div class="container column">
    <div class="game-si container wrap">

      <div class="game-si__question container column col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 padding-10">
         <div class="select_question select_question-red container align-items-stretch">
            <div class="img container align-center">
              <img src="@/assets/img/icon-books.svg" width="30" alt="Minds" class="">
            </div>
            <div class="flex-grow-1 bordered-box bordered-box-orange">
              <p>{{ question.word }}</p>
            </div>
          </div>

           <audio-player-rounded :src="question.audio" />
        </div>

      <div class="game-si__answers col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
        <div
          class="game-si__answers__image animation-bottom"
          v-for="(aswr, index) in question.answers"
          :style="{ animationDelay: `${(index / 10) + .75}s` }"
          :class="{
            right: aswr.correct && question.answered,
            wrong: !aswr.correct && aswr.selected && question.answered
          }"
          :key="`answer-${index}`"
          @click="selectQuestion(aswr)"
        >
          <span class="question_index">
            {{index + 1}}
          </span>
          <image-loader class="game-si__answers__image__content" :src="aswr.img" />
        </div>
      </div>

    </div>

    <div class="container align-items-center justify-content-end">
      <div class="margin-right-10 animation-fade">

        <transition name="fade">
          <gameFeedback :correct="verifyCorrect(question)" v-show="showFeedback"/>
        </transition>

        <div v-if="verifyCorrect(question) && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="correct_result">
            <i class="far fa-check-circle"></i>
            Alternativa correta</span>
        </div>
        <div v-if="!verifyCorrect(question) && question.answered" class="animation-bottom animation-delay-15 bottom-alert">
          <span class="wrong_result">
            <i class="far fa-times-circle"></i>
            Alternativa incorreta</span>
        </div>
      </div>
    </div>
    <modal ref="modal" v-if="!isReview" :show="showInfo" :closebtn="false" bgcolor="rgba(243, 243, 243, .95)">
      <modalSubTopic :questions="subTopic.exercise.questions" :topic="topic" :subTopic="subTopic" :close="emitClose"/>
    </modal>
  </div>
</template>

<script>
import gameFeedback from "@/components/game/feedback";
import modal from "@/components/modal";
import modalBus from "@/components/modal/modalBus";
import modalSubTopic from "@/components/modal/modalSubTopic";
import gameBus from "@/components/game/gameBus";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  components: {
    gameFeedback,
    modal,
    modalSubTopic
  },
  data() {
    return {
      showFeedback: false,
      question: {
        answers: []
      },
      index: 0,
      ended: false,
      showInfo: false
    };
  },
  props: {
    topic: {
      type: Object,
      default: () => ({})
    },
    subTopic: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapGetters({
      testMode: 'isTestMode',
      isReview: 'isReview',
      isSpeakUp: 'isSpeakUp',
      student: 'student/GET',
    }),
    exercise() {
      return this.subTopic.exercise;
    }
  },
  methods: {
    async selectQuestion(answer) {
      if (!this.question.answered) {
        answer.selected = true;
        this.question.answered = true;
        if (answer.correct) this.question.hit = true;
        else this.question.hit = false;
        this.$set(this.exercise.questions, this.index, this.question);
        this.feedback();
        await this.save(this.question);
      }
    },
    async feedback() {
      this.showFeedback = true;
      await this.$delay(1500);
      this.showFeedback = false;
      gameBus.$emit("setEnabled", true);
    },
    verifyCorrect(question) {
      if (!question.answers) return false;
      for (const aswr of question.answers) {
        if (aswr.selected && aswr.correct) return true;
      }
      return false;
    },
    async setCurrent() {
      let qst = {},
        index = 0;
      const questions = this.exercise.questions;
      for (const ind in questions) {
        index = ind;
        if (!questions[ind].answered) {
          qst = questions[ind];
          break;
        } else if (ind == questions.length - 1) {
          qst = questions[ind];
          this.ended = true;
        }
      }
      this.index = index
      if (Object.keys(this.question).length == 0 || qst._id !== this.question._id) {
        if (!qst.answered) qst.answers = this.$shuffle(qst.answers)
        this.$set(this, 'question', qst)
      }

      setTimeout(() => {
        gameBus.$emit("setEnabled", this.question.answered);
      }, 1000)
    },
    async save(question) {
      const copy = cloneDeep(question);
      let scoreQuestions = 0;
      let answered = 0;

      for (const qst of this.exercise.questions) {
        for (const aswr of qst.answers) {
          if (aswr.selected && aswr.correct) scoreQuestions++;
        }
        if (qst.answered) answered++;
      }

      const score = (scoreQuestions * 100) / this.exercise.questions.length;

      let payload = {
        points: score,
        finished: false,
        question: copy
      };

      if (answered == this.exercise.questions.length) {
        payload.finished = true;
        this.ended = true;
        await this.$delay(1500);
        this.showInfo = true;
      }

      gameBus.$emit("updateProgress", score);

      if (!!this.student.teens) {
        await this.$store.dispatch('teens/answerQuestion', payload)
        return
      }

      if (this.isSpeakUp) {
        await this.$store.dispatch("speakup/answerQuestion", {
          ...this.$route.params,
          ...payload
        })
        return
      }

      if (!this.testMode && !this.isReview)
        await this.$store.dispatch("subTopic/answerQuestion", payload);
    },
    closeModal () {
      this.showInfo = false
    },
    emitClose() {
      this.$refs["modal"].close();
    },
    async viewQuestion(index) {
      const question = this.exercise.questions[index];
      if (question && question.answered) {
        this.index = index
        this.$set(this, 'question', question)
      }
    }
  },
  watch: {
    ended(val) {
      gameBus.$emit("setEnded", val);
    },
    index(val) {
      gameBus.$emit("updateIndex", val);
    }
  },
  async mounted() {
    await this.setCurrent();
    gameBus.$on("viewQuestion", this.viewQuestion);

    gameBus.$emit("updateProgress", this.subTopic.points);
    modalBus.$on("close", this.closeModal);
    gameBus.$on("setCurrent", this.setCurrent);
  },
  beforeDestroy() {
    gameBus.$off("viewQuestion", this.viewQuestion);

    modalBus.$off("close", this.closeModal);
    gameBus.$off("setCurrent", this.setCurrent);
  }
};
</script>

<style lang="scss">
@import "./src/assets/css/components/selectQuestion";
@import "./src/assets/css/components/answerSelectQuestion";

button {
  border: none;
}

// player

.vue-sound-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #009bff;
  border-radius: 30px;
  margin-top: 20px;
  height: 42px;

  .vue-sound__player {
    width: 100%;
    padding: 5px;
    margin: 0 auto;
    display: flex;
    align-items: center;

    .vue-sound__extern-wrapper,
    .vue-sound__playback-time-current,
    .vue-sound__playback-time-separator,
    .vue-sound__playback-time-total {
      display: none !important;
    }

    .vue-sound__playback-time-wrapper {
      background: #00d4ff !important;
    }

    .vue-sound__playback-time-indicator {
      background: #f3f3f3 !important;
    }
  }

  .vue-sound__playback-time-wrapper {
    width: 100% !important;
  }

  .vue-sound__player {
    padding-right: 20px;
    box-sizing: border-box;

    a {
      margin-right: 15px;
      width: 33px;
      min-width: 33px;
      height: 33px;
      background: #f3f3f3;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .icon-stop2 {
    display: none !important;
  }
}

.icon-pause2,
.icon-play3,
.icon-stop2 {
  position: relative;

  &:before {
    position: absolute;
    top: 9px;
    left: 9px;
    color: #009bff;
  }
}

.game-si {
  height: 100%;
  justify-content: stretch;
  &__padding {
    margin: 10px;
    margin-bottom: 5px;
    border-radius: 10px;
    border: 1px solid $color-orange;
    overflow: hidden;
    @media (max-width: 540px) {
      margin: 5px;
    }
  }
  &__question {
    &__word {
      height: 80px;
      display: flex;
      justify-content: center;
      animation-delay: 0.1;
      background: $color-orange;
      color: #fff;
      font-size: 1.7rem;
      text-align: center;
      text-transform: uppercase;
      @extend .align-center;
    }
    &__audio {
      flex-basis: 70%;
    }
  }
  &__answers {
    padding: 0;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    &__image {
      flex-basis: calc(50% - 20px);
      flex-grow: 1;
      // padding: 10px;
      margin: 10px;
      height: 159px;
      border-radius: 10px;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-content: stretch;
      position: relative;
      cursor: pointer;
      overflow: hidden;
      &:after {
        content: "";
        width: 100%;
        height: 159px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99;
      }
      .question_index {
        position: absolute;
        top: 8px;
        left: 8px;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #afafaf;
        border: 2px solid #979797;
        text-align: center;
        color: #fff;
        font-size: 16px;
        z-index: 100;
      }
      &:hover {
        .question_index {
          background: #94d5ff;
          border-color: #1f70a5;
          color: #fff;
        }
      }
      &.right {
        border-color: #5ec12d;
        &:after {
          background: rgba(129, 201, 20, 0.7);
          box-shadow: none;
        }
        .question_index {
          background: #abc92e;
          border-color: #5b7100;
          color: #5b7100;
        }
      }
      &.wrong {
        border-color: #c2003c;
        &:after {
          background: rgba(201, 20, 46, 0.7);
          box-shadow: none;
        }
        .question_index {
          background: #eca4a4;
          border-color: #d62727;
          color: #d62727;
        }
      }
      &__content {
        border-radius: 10px;
        flex-grow: 1;
      }
      @media (max-width: 540px) {
        padding: 5px;
      }
    }
  }
  &__options {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-end;
    &__btn {
      align-self: center;
      padding: 10px 30px;
      margin-right: 5px;
      border-radius: 100px;
      background-color: #3bbfd4;
      font-weight: 600;
      font-size: 14px;
      color: #f3f3f3;
      letter-spacing: 1.5px;
      &:hover,
      &:focus {
        background-color: #28a1b4;
        cursor: pointer;
        outline: none;
      }
      &:disabled {
        filter: grayscale(90%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/listenSelectImageQuestion.vue